import { List, ListItem, ListItemAvatar, ListItemText, Tooltip } from '@mui/material';
import type { User } from 'app/collab/types';
import { UserAvatar } from '../user-avatar/index.js';
import { UserAvatarGroup } from '../user-avatar-group/index.js';

export type ProjectUsersProps = {
  readonly users: User[];
};

export function ProjectUsers({ users }: ProjectUsersProps) {
  const userList = (
    <ul>
      {users.map((user) => {
        const name = user.fullName ?? user.email;
        return (
          <ListItem key={user.id}>
            <ListItemAvatar>
              <UserAvatar user={user} size={2.8} />
            </ListItemAvatar>
            <ListItemText primary={name} />
          </ListItem>
        );
      })}
    </ul>
  );
  return (
    <Tooltip title={userList}>
      <div>
        <UserAvatarGroup users={users} max={4} />
      </div>
    </Tooltip>
  );
}
